import { useModalInstallStyles } from "./modal-install.styles";
import { usePageContextHardware } from "../../context/hardware-context";
import { ModalHardwareInstall } from "@/module/modal-hardware-install/index";

export const ModalInstall = () => {
  const { styles } = useModalInstallStyles();
  const { controllerHardwareInstall } = usePageContextHardware();

  return (
    <ModalHardwareInstall
      className={styles.root}
      controller={controllerHardwareInstall}
    />
  );
};
